/*
 * Evernava PDP Main — swipeable gallery, colour picker, add-to-cart label sync.
 *
 * Gallery: every media item is a real slide in one horizontal scroll-snap track.
 * Swiping is native browser scrolling, so it feels right on touch and needs no
 * carousel library. Arrows, thumbnails, dots and the colour swatches never swap
 * an image src — they all just scroll the same track, which keeps one source of
 * truth for "which image is showing". Liquid renders the selected variant's
 * photo as slide 1, so there is nothing to reposition on load.
 *
 * Bundle tiers, per-unit variant choice and bundle pricing are owned by the
 * Pumper Bundles app block inside #bundle-save. Nothing here touches quantity or
 * intercepts add-to-cart.
 */
(function () {
  var MDASH = '—';

  function init(root) {
    if (!root || root.getAttribute('data-ev-init') === '1') return;
    root.setAttribute('data-ev-init', '1');

    var variantInput = root.querySelector('input[name="id"]');
    var colorName = root.querySelector('.ev-eyebrow-val');
    var stickyColor = root.querySelector('.ev-sticky-color');

    var mainId = variantInput ? variantInput.value : '';
    var names = {};
    root.querySelectorAll('.ev-sw').forEach(function (s) {
      names[s.getAttribute('data-variant')] = s.getAttribute('data-name') || '';
    });

    function nameOf(id) {
      return names[id] || '';
    }

    /* ---------------------------------------------------------------
     * Gallery
     * ------------------------------------------------------------- */

    var track = root.querySelector('.ev-gal-track');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.ev-gal-slide')) : [];
    var dots = Array.prototype.slice.call(root.querySelectorAll('.ev-gal-dot'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.ev-thumb'));
    var prevBtn = root.querySelector('[data-gal-prev]');
    var nextBtn = root.querySelector('[data-gal-next]');
    var strip = thumbs.length ? thumbs[0].parentElement : null;
    var current = 0;

    function paintGallery(i) {
      current = i;
      dots.forEach(function (d, n) {
        d.classList.toggle('is-on', n === i);
      });
      thumbs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
      if (prevBtn) prevBtn.disabled = i <= 0;
      if (nextBtn) nextBtn.disabled = i >= slides.length - 1;

      // Keep the active thumbnail visible without moving the page itself.
      var active = thumbs[i];
      if (active && strip && strip.scrollWidth > strip.clientWidth) {
        var left = active.offsetLeft - (strip.clientWidth - active.clientWidth) / 2;
        try {
          strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        } catch (err) {
          strip.scrollLeft = Math.max(0, left);
        }
      }
    }

    /*
     * Always jump instantly.
     *
     * `scroll-snap-stop: always` on the slides silently cancels a programmatic
     * SMOOTH scroll in Chrome — measured on this page: scrollTo({behavior:
     * 'smooth'}) left scrollLeft at 0, the same call with 'auto' landed exactly
     * on the slide, and dropping scroll-snap-stop made the smooth call work
     * again. Snap-stop is worth keeping (it stops one fast flick from skipping
     * five images out of fifteen), so the arrows, thumbnails, dots and swatches
     * cut instead of gliding. Swiping is untouched and still scrolls natively.
     */
    function goTo(i) {
      if (!track || !slides.length) return;
      if (i < 0) i = 0;
      if (i > slides.length - 1) i = slides.length - 1;
      var left = i * track.clientWidth;
      try {
        track.scrollTo({ left: left, behavior: 'auto' });
      } catch (err) {
        track.scrollLeft = left;
      }
      paintGallery(i);
    }

    function indexForSrc(src) {
      if (!src) return -1;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-src') === src) return i;
      }
      return -1;
    }

    if (track && slides.length) {
      var ticking = false;
      track.addEventListener(
        'scroll',
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            ticking = false;
            var w = track.clientWidth || 1;
            var i = Math.round(track.scrollLeft / w);
            if (i !== current) paintGallery(i);
          });
        },
        { passive: true }
      );

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(current - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(current + 1);
        });
      }

      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          goTo(parseInt(d.getAttribute('data-index'), 10) || 0);
        });
      });

      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          goTo(parseInt(t.getAttribute('data-index'), 10) || 0);
        });
      });

      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          goTo(current + 1);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          goTo(current - 1);
        }
      });

      // A resize changes slide width, so the saved scrollLeft would land between
      // two slides. Re-anchor on the slide that was showing.
      var rt = null;
      window.addEventListener('resize', function () {
        if (rt) clearTimeout(rt);
        rt = setTimeout(function () {
          goTo(current);
        }, 150);
      });
    }

    /* ---------------------------------------------------------------
     * Add-to-cart label ↔ selected Pumper tier
     * ------------------------------------------------------------- */

    var bundleZone = root.querySelector('#bundle-save');
    var atcLabels = root.querySelectorAll('.ev-atc-label, .ev-sticky-btn span');
    var baseLabel = '';

    if (atcLabels.length) {
      baseLabel = String(atcLabels[0].textContent).split(MDASH)[0].trim();
    }

    function selectedTierPrice() {
      if (!bundleZone) return null;
      var checked = bundleZone.querySelector('input[name="cb"]:checked');
      if (!checked) return null;
      var index = parseInt(checked.value, 10);
      if (isNaN(index) || index < 1) return null;
      var el = bundleZone.querySelector('#pumper_totalAmount_' + (index - 1));
      if (!el) return null;
      var text = String(el.textContent).replace(/\s+/g, ' ').trim();
      if (!text || !/\d/.test(text)) return null;
      return text;
    }

    function syncAtcLabel() {
      if (!atcLabels.length || !baseLabel) return;
      var price = selectedTierPrice();
      var next = price ? baseLabel + ' ' + MDASH + ' ' + price : baseLabel;
      atcLabels.forEach(function (el) {
        if (/sold out/i.test(el.textContent) && !price) return;
        if (el.textContent !== next) el.textContent = next;
      });
    }

    if (bundleZone && atcLabels.length) {
      var pending = null;
      var queueSync = function () {
        if (pending) clearTimeout(pending);
        pending = setTimeout(syncAtcLabel, 60);
      };

      bundleZone.addEventListener('click', queueSync, true);
      bundleZone.addEventListener('change', queueSync, true);

      if ('MutationObserver' in window) {
        new MutationObserver(queueSync).observe(bundleZone, {
          subtree: true,
          childList: true,
          characterData: true
        });
      }

      queueSync();
      setTimeout(syncAtcLabel, 800);
      setTimeout(syncAtcLabel, 2500);
    }

    /* ---------------------------------------------------------------
     * Colour picker
     * ------------------------------------------------------------- */

    function announce(id) {
      if (!variantInput) return;
      try {
        variantInput.dispatchEvent(new Event('input', { bubbles: true }));
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        document.dispatchEvent(
          new CustomEvent('variant:change', { detail: { variantId: id }, bubbles: true })
        );
      } catch (err) {
        /* no-op */
      }
    }

    function selectMain(id, silent) {
      if (!id) return;
      mainId = id;
      if (variantInput) variantInput.value = id;

      var active = null;
      root.querySelectorAll('.ev-sw').forEach(function (s) {
        var on = s.getAttribute('data-variant') === id;
        if (on) active = s;
        s.classList.toggle('is-on', on);
        s.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      var nm = nameOf(id);
      if (colorName) colorName.textContent = nm;
      if (stickyColor) stickyColor.textContent = nm;

      if (active) {
        var idx = indexForSrc(active.getAttribute('data-img'));
        if (idx >= 0) goTo(idx);
        var avail = active.getAttribute('data-available') === '1';
        root.querySelectorAll('.ev-atc, .ev-sticky-btn').forEach(function (b) {
          b.disabled = !avail;
        });
      }

      if (!silent && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', id);
          history.replaceState({}, '', u.toString());
        } catch (err) {
          /* no-op */
        }
      }

      announce(id);
    }

    root.querySelectorAll('.ev-sw').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        var id = sw.getAttribute('data-variant');
        if (!id) return;
        e.preventDefault();
        selectMain(id);
      });
    });

    var rate = root.querySelector('.ev-rate');
    if (rate) {
      rate.addEventListener('click', function (e) {
        var target = document.getElementById('product-reviews');
        if (!target) return;
        e.preventDefault();
        var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      });
    }

    var sticky = root.querySelector('.ev-sticky');
    var anchor = root.querySelector('.ev-atc-wrap');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (en) {
            var narrow = window.matchMedia('(max-width:900px)').matches;
            var allowed = narrow
              ? sticky.getAttribute('data-mobile') === 'true'
              : sticky.getAttribute('data-desktop') === 'true';
            sticky.hidden = en.isIntersecting || !allowed;
          });
        },
        { rootMargin: '0px 0px -100% 0px' }
      ).observe(anchor);
    }

    if (stickyColor) stickyColor.textContent = nameOf(mainId);

    paintGallery(0);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('.ev-pdp').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
